export default __webpack_public_path__ + "static/media/watermark-LB.ba923e55.png";